<template>
  <div class="changebns">
    <toptitle :title1="titlework" />
    <section class="menu">
      <div @click="isShowDeptPicker" class="choosedate">{{ deptDrop }}</div>
    </section>
    <van-popup v-model="show2" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns2"
        @confirm="onConfirm2"
        @cancel="onCancel"
      />
    </van-popup>
    <div class="echart-data">
      <div class="echart-box-shaodow">
        <echart-pies
          v-if="flag"
          :itemsData="items_six"
          titletop="性别信息分布"
          id="echar6"
        ></echart-pies>
      </div>
      <div class="echart-box-shaodow">
        <echart-bar
          v-if="flag"
          :itemsData="items_one"
          id="echart1"
          titletop="年龄信息分布"
        ></echart-bar>
      </div>
      <div class="echart-box-shaodow">
        <echart-pielab
          v-if="flag"
          :itemsData="items_five"
          titletop="籍贯信息分布"
          id="echar5"
        ></echart-pielab>
      </div>

      <div class="echart-box-shaodow">
        <echart-pie
          v-if="flag"
          :itemsData="items_two"
          id="echart2"
          titletop="学历信息分布"
        ></echart-pie>
      </div>
      <div class="echart-box-shaodow">
        <echart-roster
          v-if="flag"
          :itemsData="items_three"
          titletop="工龄信息分布"
          id="echart3"
        ></echart-roster>
      </div>

      <div class="echart-box-shaodow">
        <echart-circle
          v-if="flag"
          :itemsData="items_four"
          id="echart4"
          titletop="员工入离职情况"
        ></echart-circle>
      </div>
    </div>
  </div>
</template>

<script>
  import toptitle from '../components/toptitle';
  import echartPies from '../components/analysisechart/echart-pies';
  import echartPie from '../components/analysisechart/echart-pie';
  import echartPielab from '../components/analysisechart/echart-pielab';
  import echartBar from '../components/analysisechart/echart-bar';
  import echartCircle from '../components/analysisechart/echart-circle';
  import echartRoster from '../components/analysisechart/echart-roster';
  import { getMyDeptDataApi, getTeamDeptData } from '../request/api';

  export default {
    name: 'teamanalysis',
    data() {
      return {
        titlework: '团队分析',
        show2: false,
        flag: false,
        columns2: [],
        department: [],
        deptDrop: '部门',
        items_one: [], //年龄信息分布
        items_two: [], //学历信息分布
        items_three: [], //华峰工龄分析
        items_four: [], //员工层级分析
        items_five: [], //籍贯分析
        items_six: [] //性别分析
      };
    },
    components: {
      toptitle,
      echartPies,
      echartPie,
      echartPielab,
      echartBar,
      echartRoster,
      echartCircle
    },
    mounted() {
      this.getDeptList();
    },
    watch: {
      textValue(newVal, oldVal) {
        this.reqTeamAnalysisData();
      }
    },
    computed: {
      textValue() {
        return this.deptDrop;
      }
    },
    methods: {
      /**
       * 部门获取
       * **/
      getDeptList() {
        let params = {
          EMPLID: sessionStorage.getItem('EMPLID')
        };
        getMyDeptDataApi(params).then(res => {
          if (res.CODE === 200) {
            this.department = res.DATA;

            this.columns2 = this.department.map(item => {
              return item.DEPT_DESCR;
            });
            if (this.deptDrop == '部门') {
              this.deptDrop = this.department[0].DEPT_DESCR;
            }
            this.reqTeamAnalysisData();
          }
        });
      },
      isShowDeptPicker() {
        this.show2 = true;
      },

      onCancel() {
        this.show2 = false;
      },

      onConfirm2(value) {
        this.deptDrop = value;
        this.show2 = false;
        this.reqTeamAnalysisData();
      },

      /**
       *获取团队数据分析数据
       *
       **/
      reqTeamAnalysisData() {
        const vm = this;
        let teamAnaly = '';
        let emplid = '';
        this.department.forEach(element => {
          if (this.deptDrop == element.DEPT_DESCR) {
            teamAnaly = element.DEPTID;
            emplid = element.EMPLID;
          }
        });

        let params = {
          DEPTID: teamAnaly,
          EMPLID: emplid
        };
        getTeamDeptData(params).then(res => {
          if (res.CODE === 200) {
            const dataAnalysis = res.DATA;

            vm.items_one = dataAnalysis.AGE.map(item => {
              return {
                value: item.VALUE,
                name: item.NAME
              };
            });
            vm.items_two = dataAnalysis.EDU.map(item => {
              return {
                value: item.VALUE,
                name: item.NAME
              };
            });

            vm.items_three = dataAnalysis.COMAGE.map(item => {
              return {
                value: item.VALUE,
                name: item.NAME
              };
            });
            vm.items_four = dataAnalysis.EMPL_LVL.map(item => {
              return {
                value: item.VALUE,
                name: item.NAME
              };
            });
            vm.items_four = vm.items_four.filter(item => {
              return item.name !== '本年调入' && item.name !== '本年调出';
            });
            vm.items_five = dataAnalysis.HOMETOWN.map(item => {
              return {
                value: item.VALUE,
                name: item.NAME
              };
            });
            vm.items_six = dataAnalysis.SEX.map(item => {
              return {
                value: item.VALUE,
                name: item.NAME
              };
            });
            vm.flag = true;
          }
        });
      }
    }
  };
</script>

<style lang="less" scoped>
  .menu {
    display: flex;
    border-top: 1px solid #e5e5e5;
    div {
      width: 100%;
      box-shadow: 0;
    }
    .choosedate {
      background: white;
      height: 48px;
      line-height: 48px;
      text-align: center;
      color: #323233;
      font-size: 15px;
      border-left: 1px solid #e5e5e5;
    }
    .choosedate:after {
      display: inline-block;
      content: '';
      position: relative;
      top: 2px;
      margin-left: 3px;
      width: 0;
      height: 0;
      border: 5px solid transparent;
      border-top-color: #999;
    }
  }

  .echart-box-shaodow {
    transition: 3s;
    margin: 10px;
    background-color: #fff;
    text-align: center;
  }
</style>
